import EventEmitter from "./EventEmitter"
import * as THREE from "three"
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'  
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'

export default class Resources extends EventEmitter {
    constructor(sources) {
        super()
        this.sources = sources

        // Setup 
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        this.setLoader()

        // Loading
        this.startLoading()
    }

    setLoader() {
        this.loaders = {}
        this.loadingManager = null // LoadingManager 
        this.loaders.gltfLoader = new GLTFLoader(
            // this.loadingManager
        )
        this.loaders.textureLoader = new THREE.TextureLoader(
            // this.loadingManager
        )
        this.loaders.fontLoader = new FontLoader(
            // this.loadingManager
        )
    }

    startLoading() {
        // Load each source
        for(const source of this.sources) {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'font')
            {
                this.loaders.fontLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            // else if(source.type === 'cubeTexture')
            // {
            //     this.loaders.cubeTextureLoader.load(
            //         source.path,
            //         (file) =>
            //         {
            //             this.sourceLoaded(source, file)
            //         }
            //     )
            // }
        }
    }
    sourceLoaded(source, file) {
        this.items[source.name] = file

        this.loaded++

        if(this.loaded === this.toLoad) {
            this.trigger('ready')
        }
    }
}